module.exports = __webpack_public_path__ + "img/mi-document.bbcd51a2.svg";